import { render } from "./MediumContentBase.vue?vue&type=template&id=416c577e&scoped=true"
import script from "./MediumContentBase.vue?vue&type=script&lang=js"
export * from "./MediumContentBase.vue?vue&type=script&lang=js"

import "./MediumContentBase.vue?vue&type=style&index=0&id=416c577e&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416c577e"]])

export default __exports__